var _a;
import config from "@/services/config/config";
const backgroundColor = (_a = config.skin.theme) === null || _a === void 0 ? void 0 : _a.appBackground;
if (backgroundColor) {
    document.documentElement.style.setProperty("--background", backgroundColor);
}
